import {
  SR_CONTRACT_START,
  SR_CONTRACT_END,
  SR_CONTRACT_DATA,
  SR_CONTRACT_BY_ID,
  SR_TYPE_CONFIG_DATA,
  SR_TYPE_CONFIG_DATA_ID,
  SR_CONTRACT_RESET,
  SR_POSTED_LOADING_START,
  SR_POSTED_LOADING_END,
  SR_POSTED_RESULTS_SUCCESS,
  SR_CALC_RESULTS_SUCCESS,
  SR_CALC_ANALYSIS_RESULTS_SUCCESS,
} from '../../actions/SupplierRebate/ActionTypes';

const initialState = {
  loading: false,
  contractData: [],
  contractDataById: {},
  typeConfigData: [],
  typeConfigDataById: {},
  postedLoading: false,
  postedResults: null,
  supplierRebateCalculationDataResults: [],
  supplierRebateCalculationAnalysisDataResults: [],
};

const SupplierRebateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SR_CONTRACT_DATA:
      return { ...state, contractData: action.data };
    case SR_CONTRACT_BY_ID:
      return { ...state, contractDataById: action.data };
    case SR_TYPE_CONFIG_DATA:
      return { ...state, typeConfigData: action.data };
    case SR_TYPE_CONFIG_DATA_ID:
      return { ...state, typeConfigDataById: action.data };
    case SR_CONTRACT_START:
      return { ...state, loading: true };
    case SR_CONTRACT_END:
      return { ...state, loading: false };
    case SR_CONTRACT_RESET:
      return initialState;
    case SR_POSTED_LOADING_START:
      return { ...state, postedLoading: true };
    case SR_POSTED_LOADING_END:
      return { ...state, postedLoading: false };
    case SR_POSTED_RESULTS_SUCCESS:
      return { ...state, postedResults: action.data };
    case SR_CALC_RESULTS_SUCCESS:
      return { ...state, supplierRebateCalculationDataResults: action.data };
    case SR_CALC_ANALYSIS_RESULTS_SUCCESS:
      return { ...state, supplierRebateCalculationAnalysisDataResults: action.data };
    default:
      return state;
  }
};

export default SupplierRebateReducer;
